import { showBettoAlert } from "@layouts/betto/components/Alert/showBettoAlert";

const SUCCESS_BET_COMMAND = "successBet";
const ALERT_DEBOUNCE_MS = 1500;

export const wireBettoDigitainBetConfirmedAlert = (showAlert) => {
	if (typeof showAlert !== "function") {
		return () => {};
	}

	let lastAlertAt = 0;
	let previousEventsHandler = null;

	const triggerBetConfirmedAlert = () => {
		const now = Date.now();
		if (now - lastAlertAt < ALERT_DEBOUNCE_MS) {
			return;
		}

		lastAlertAt = now;
		showBettoAlert(showAlert, "bet-confirmed");
	};

	const handleWindowMessage = (event) => {
		const command = event?.data?.command;
		if (command === SUCCESS_BET_COMMAND) {
			triggerBetConfirmedAlert();
		}
	};

	if (window.SportFrame?.setts) {
		previousEventsHandler = window.SportFrame.setts.eventsHandler;
		window.SportFrame.setts.eventsHandler = (args) => {
			if (args?.eventType === SUCCESS_BET_COMMAND) {
				triggerBetConfirmedAlert();
			}

			if (typeof previousEventsHandler === "function") {
				previousEventsHandler(args);
			}
		};
	}

	window.addEventListener("message", handleWindowMessage);

	return () => {
		window.removeEventListener("message", handleWindowMessage);

		if (window.SportFrame?.setts && previousEventsHandler) {
			window.SportFrame.setts.eventsHandler = previousEventsHandler;
		}
	};
};
